const state = {
  forms: []
}

const getters = {
  hasForm: state => identifier => state.forms.some(item => item === identifier)
}

const actions = {
  addOrUpdateForm ({ commit }, formIdentifier) {
    commit('addOrUpdateForm', formIdentifier)
  },

  removeForm ({ commit }, formIdentifier) {
    commit('removeForm', formIdentifier)
  }
}

const mutations = {
  addOrUpdateForm (state, formIdentifier) {
    state.forms.push(formIdentifier)
  },

  removeForm (state, identifier) {
    state.forms = state.forms.filter(item => item !== identifier)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
